import React from "react";
import PropTypes from "prop-types";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  COLOR_DANGER,
  COLOR_GREEN,
} from "../../Colors";

const EmployeeProgress = ({ color, employee, percentage }) => (
  <div className="col-10 offset-1 col-xl p-0 ml-xl-4 mr-xl-4 mt-2 mt-xl-0">
    <OverlayTrigger
      placement="bottom"
      overlay={
        <Popover
          placement="bottom"
          id="popover-basic"
          title={
            parseInt(percentage) < 100 ? "Como melhorar?" : "Tudo certo"
          }
        >
          {parseInt(percentage) < 100 && (
            <div className="p-2">
              {employee.invalidos > 0 && (
                <div
                  style={{
                    color: COLOR_DANGER,
                  }}
                >
                  <FontAwesomeIcon icon="ban" />{" "}
                  <b>Documento(s) Inválido(s)</b>: Caso o documento
                  tenha sido recusado, é possível reenviá-lo ao contrato
                  que o fez, ou para todos os contratos, caso o
                  documento tenha expirado deve-se ser enviado a todos
                  os contratos
                </div>
              )}
            </div>
          )}
          {parseInt(percentage) >= 100 && (
            <div className="p-2" style={{ color: COLOR_GREEN }}>
              <FontAwesomeIcon icon="check" /> Nenhuma pendência
            </div>
          )}
        </Popover>
      }
    >
      <div className="progress mt-4">
        <div
          className="progress-bar"
          style={{
            background: color,
            width: parseInt(employee.percentagem * 100) + "%",
          }}
          role="progressbar"
          aria-valuenow={parseInt(employee.percentagem * 100)}
          aria-valuemin="0"
          aria-valuemax="100"
          id="progressbar"
        >
          <span
            className="progress-indicator"
            style={{
              backgroundColor: color,
              borderColor: color,
              left: parseInt(percentage) + "%",
            }}
          >
            {parseInt(employee.percentagem * 100)}%
          </span>
        </div>
      </div>
    </OverlayTrigger>
    <div
      className="w-100 text-center font-weight-500 pt-2"
      style={{ fontSize: "15px" }}
    >
      {employee.aguardando + employee.invalidos > 0 && (
        <span className="d-block w-100">
          {employee.invalidos > 0 && (
            <>
              HÁ <b>{employee.invalidos}</b> PENDÊNCIA(S)
            </>
          )}
          {employee.aguardando > 0 && (
            <>
              {employee.invalidos > 0 ? " E" : "HÁ"}{" "}
              <b>{employee.aguardando}</b> AGUARDANDO APROVAÇÃO
            </>
          )}
        </span>
      )}
    </div>
  </div>
);

EmployeeProgress.propTypes = {
  color: PropTypes.string,
  employee: PropTypes.object,
  percentage: PropTypes.number,
};

export default EmployeeProgress;
